<script>
  import mensagemServico from '~modulos/mensagem/servico';

  import { modal, tabs, tab } from 'vue-strap';  
  import MensagensConteiner from '~modulos/mensagem/componentes/MensagensConteiner.vue';
  import CentralMensagens from '~modulos/central-mensagens/componentes/CentralMensagens.vue';
  import Radio from '~componentes/Radio.vue';

  import tipoUsuario from '~js/tipo-usuario';

  const MODULOS_CENTRAL = {
    SolCompra: 1,
    SolBolsa: 2,
    SolCursoEventoServico: 3,
    SolPagamentoPF: 4,
    SolAdiantamento: 5,
    SolReembolso: 6,
    SolFaturamento: 7,
    SolImportacao: 8,
    SolPagamentoPJ: 9,
    SolReembolsoTerceiro: 10,
    SolTransferencia: 15,
    SolCancelamentoContrato: 16,
    SolContratacaoPessoal: 18,
  };

  export default {
    components: { modal, tabs, tab, MensagensConteiner, Radio, CentralMensagens },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      tipo: {
        type: String,
        required: true,
      },
      id: {
        required: true,
      },
      numero: {
        required: true,
      }
    },
    data() {
      return {
        mensagens: [],
        tabIndex: 0,
        mensagemObj: {},
        internaExterna: 0,
        carregando: true,
        textoTipoMensagem: "",
        filtros: {
          id: '',
          modulo: '',
          internaexterna: 1,
        },
        erroEnvioMensagem: false,
        textoErroEnvio: 'Erro ao enviar mensagem.',
        usuario: this.$storage.usuario(),
        tipoUsuario: tipoUsuario,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar() {
        this.lista();
        this.definirTitulo();
        this.tabIndex = 0;
        this.preencherDados();
      },
      definirTitulo() {
        if (this.tipo === 'SolCompra') {
          this.textoTipoMensagem = 'Solicitação de Compra';
        }

        if (this.tipo === 'SolBolsa') {
          this.textoTipoMensagem = 'Solicitação de ' + this.configuracao.nomeModuloSolContratos;
        }

        if (this.tipo === 'SolCursoEventoServico') {
          this.textoTipoMensagem = 'Solicitação de ' + this.configuracao.nomeModuloSolCursoEventoServico;
        }  

        if (this.tipo === 'SolAdiantamento') {
          this.textoTipoMensagem = 'Solicitação de Adiantamento';
        }  

        if (this.tipo === 'SolReembolso') {
          let passagem = this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '';
          let adiantamento = this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '';

          this.textoTipoMensagem = 'Solicitação de Diária ' + passagem + adiantamento;
        }

        if (this.tipo === 'SolReembolsoTerceiro') {
          this.textoTipoMensagem = 'Solicitação de Reembolso Terceiro';
        }

        if (this.tipo === 'SolPagamentoPF') {
          this.textoTipoMensagem = 'Solicitação de Pegamento Pessoa Física';
        }

        if (this.tipo === 'SolPagamentoPJ') {
          this.textoTipoMensagem = 'Solicitação de Pegamento Pessoa Jurídica';
        }

        if (this.tipo === 'SolFaturamento') {
          this.textoTipoMensagem = 'Solicitação de Faturamento';
        }

        if (this.tipo === 'SolImportacao') {
          this.textoTipoMensagem = 'Solicitação de Importação';
        }

        if (this.tipo === 'SolTransferencia') {
          this.textoTipoMensagem = 'Solicitação de Transferência';
        }

        if (this.tipo === 'SolCancelamentoContrato') {
          this.textoTipoMensagem = 'Solicitação Cancelamento Contrato';
        }

        if (this.tipo === 'SolContratacaoPessoal') {
          this.textoTipoMensagem = 'Solicitação Contratação Pessoal';
        }

        if (this.tipo === 'MensalidadePessoaFisica') {
          this.textoTipoMensagem = 'Mensalidade';
        }
      },
      lista() {
        this.carregando = true;

        this.filtros.id = this.id;
        this.filtros.modulo = this.tipo;

        mensagemServico
          .listaChat(this.filtros)
          .then(resultado => {
            this.mensagens = resultado;

            this.carregando = false;
          });
      },
      preencherDados() {
        if (this.tipo === 'SolCompra')
          var mod = 1;
        if (this.tipo === 'SolBolsa')
          var mod = 2;
        if (this.tipo === 'SolCursoEventoServico')
          var mod = 3; 
        if (this.tipo === 'SolPagamentoPF')
          var mod = 4;
        if (this.tipo === 'SolAdiantamento')
          var mod = 5; 
        if (this.tipo === 'SolReembolso')
          var mod = 6; 
        if (this.tipo === 'SolFaturamento')
          var mod = 7; 
        if (this.tipo === 'SolImportacao')
          var mod = 8; 
        if (this.tipo === 'SolPagamentoPJ')
          var mod = 9; 
        if (this.tipo === 'SolReembolsoTerceiro')
          var mod = 10;
        if (this.tipo === 'SolTransferencia')
          var mod = 15;
        if (this.tipo === 'SolCancelamentoContrato')
          var mod = 16;
        if (this.tipo === 'SolContratacaoPessoal')
          var mod = 18
        if (this.tipo === 'MensalidadePessoaFisica')
          var mod = 19

        this.mensagemObj.modulo = mod;
        this.mensagemObj.usuarioSistema = this.$storage.usuario().nome;        
      },
      salvar() {
        $('#enviar').button('loading');

        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              if (this.usuario.tipoUsuario === this.tipoUsuario.Funcionario)
                this.mensagemObj.internaExterna = this.internaExterna
              else
                this.mensagemObj.internaExterna = 1;

              this.mensagemObj.id = this.id;
              const copiaMensagem = JSON.parse(JSON.stringify(this.mensagemObj));

              return mensagemServico.salvar(copiaMensagem)
            } else {
              throw new Error("validacao");
            }
          })
          .then(id => {
            $('#enviar').button('reset');
            this.mensagemObj.campoMensagem = '';
            this.internaExterna = 0;
            this.carregar();
          })
          .catch(erro => {
            $('#enviar').button('reset');
            this.textoErroEnvio = erro && erro.data && erro.data.message ? erro.data.message : 'Erro ao enviar mensagem.';
            this.erroEnvioMensagem = true;
          });
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
      numeroConversa() {
        return /^[0-9]+$/.test('' + this.numero) ? +this.numero : 0;
      },
      moduloCentral() {
        return MODULOS_CENTRAL[this.tipo] || 0;
      },
      usarCentral() {
        const tipo = this.usuario && this.usuario.tipoUsuario;

        if (!this.moduloCentral) return false;
        return tipo === this.tipoUsuario.Coordenador || tipo === this.tipoUsuario.Funcionario || tipo === this.tipoUsuario.GestaoMensagens;
      },
    },
    mounted() {
      this.tabIndex = 0;        
    },
    validarDados() {
      return this.$validator.validateAll();
    },
  }
</script>

<template>
  <div>

    <modal
      v-if="usarCentral"
      ref="modal"
      class="modal-centralizado"
      :value="show"
      effect="fade"
      @closed="$emit('fechado')"
      @opened="definirTitulo"
      :large="true">
      <span slot="modal-header"></span>

      <div slot="modal-body" class="modal-conversa-corpo">
        <central-mensagens v-if="show && numeroConversa > 0" :key="moduloCentral + '-' + numeroConversa"
                           :modulo-unico="moduloCentral" :numero-unico="numeroConversa" :fechar-modal="true"
                           @fechar="$refs.modal.action(false, 3)"></central-mensagens>
      </div>

      <span slot="modal-footer"></span>
    </modal>

    <modal
      v-else
      ref="modal"
      :value="show"
      effect="fade"
      @closed="mensagens = [],mensagemObj = {}, $emit('fechado')"
      @opened="carregar"
      :large="true">
      <div slot="modal-header" class="modal-header">Mensagens da {{ textoTipoMensagem }} #{{ numero }}</div>

      <tabs :nav-style="'tabs'" :justified="true" v-model="tabIndex">
        <tab header="Mensagens">

          <div class="table-responsive">
            <div v-if="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </div>

            <input type="radio"
                   id="internaexterna1"
                   v-model="filtros.internaexterna"
                   :value=1
                   :inline="true"
                   v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)"
                   v-on:change="lista" />
            <label for="internaexterna1" class="margin-right-10" v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)">Todas</label>

            <input type="radio"
                   id="internaexterna2"
                   v-model="filtros.internaexterna"
                   :value=2
                   :inline="true"
                   v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)"
                   v-on:change="lista" />
            <label for="internaexterna2" class="margin-right-10" v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)">Interna</label>

            <input type="radio"
                   id="internaexterna3"
                   v-model="filtros.internaexterna"
                   :value=3
                   :inline="true"
                   v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)"
                   v-on:change="lista" />
            <label for="internaexterna3" class="margin-right-10" v-if="(usuario.tipoUsuario === tipoUsuario.Funcionario)">Externa</label>

            <mensagens-conteiner :mensagem="mensagens" v-if="!carregando && mensagens.length > 0"></mensagens-conteiner>

          </div>

        </tab>
        <tab header="Enviar mensagem">
          <div>
            <form @submit.prevent="this.$validator.validateAll()">

              <div class="row">
                <div class="col-lg-12">
                  <div class="panel-body">
                    <div class="form-group" :class="{'has-error': errors.has('campoMensagem'), 'required': tabIndex === 1}">
                      <label class="control-label margin-right-10" for="campomensagem">Mensagem</label>

                        <radio v-model="internaExterna"
                                :selected-value="0"
                                type="success"
                                :inline="true"
                                v-if="usuario.tipoUsuario === tipoUsuario.Funcionario"
                                class="margin-right-10">
                          Interna
                        </radio>
                        <radio v-model="internaExterna"
                                :selected-value="2"
                                type="success"
                                v-if="usuario.tipoUsuario === tipoUsuario.Funcionario"
                                :inline="true">
                          Externa
                        </radio>

                        <textarea class="form-control"
                                  id="campoMensagem"
                                  v-model="mensagemObj.campoMensagem"
                                  data-vv-name="campoMensagem"
                                  data-vv-as="mensagem"
                                  v-validate="'required'"
                                  style="resize: vertical">
                      </textarea>

                        <p class="text-danger" v-show="errors.has('campoMensagem')">{{ errors.first('campoMensagem') }}</p>
                      </div>
                    </div>
                </div>
              </div>

              <div class="alert alert-danger" role="alert" v-show="erroEnvioMensagem">
                {{ textoErroEnvio }}
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <button id="enviar"
                            type="button"
                            class="btn btn-primary"
                            @click="salvar"
                            data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Enviando...">
                      <i class="fa fa-paper-plane"></i>
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </tab>
      </tabs>

      <div slot="modal-footer" class="modal-footer">
        <button 
          type="button" 
          class="btn btn-default" 
          @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
    
  </div>
</template>

<style>
  .modal-conversa-corpo { border-radius: 6px; overflow: hidden; }
  .modal-conversa-corpo .cm-page.cm-page-unica { height: 82vh; min-height: 420px; border: none; }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalMensagem.vue